module.exports = __webpack_public_path__ + "286f24432466b6d82a1eadb779091939.png";